import React, { useEffect, useRef, useState } from "react";
import "./allQuestions.css";
import Questionnobox from "../onreview_component/question_no_box/Questionnobox";
import UploadQuestion from "./UploadQuestion";
import McqQuestion from "./McqQuestion";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../axios";
import ViewEvaluation from "../../Completed/evaluation/ViewEvaluation";
import moment from "moment";
import {
  calculateDeadlineTime,
  dateHelperSchedulePlusDuration,
} from "../../../../Utils/assessment";
import { timeHelper, dateHelper } from "../../../../Utils/datetime_helper";
import ErrorDialog from "../../Create_Assessment/create_published/ErrorDialogue";
import { toast } from "react-toastify";
import AdaptiveEvalutionGraph from "../../Completed/CompletedAdaptiveQues/AdaptiveEvalutionGraph";
import ProgressBar from "./Progressbar/ProgressBar";
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PopupforNoQsAttempt from "./PopupforNoQsAttempt";

const AllQuestions = () => {
  const assessmentReviewDialogRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [nextQuestion, setNextQuestion] = useState(0);
  const { state } = useLocation();
  const [studentResponse, setStudentResponse] = useState({});
  const [responseAnswers, setResponseAnswers] = useState([]);
  const [publishResult, setPublishResult] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [isDisableSubmit, setIsDisableSubmit] = useState(false);
  const [evaluationData, setEvaluationData] = useState({});
  const [studentResults, setStudentResults] = useState([]);
  const [isFirstSubmit, setIsFirstSubmit] = useState(false);
  const [newResultId, setNewResultId] = useState(null);
  const [openGraphPopup, setOpenGraphPopup] = useState(false);
  const [resultIds, setResultIds] = useState([]);
  const [difficulty, setDifficulty] = useState(0);
  const [skillsValue, setSkillsValue] = useState(0);
  const [difficultyData, setDifficultyData] = useState(null);
  const [studentMarksDetails, setStudentMarksDetails] = useState([]);
  const [studentResultData, setStudentResultData] = useState([]);
  const [chartData, setChartData] = useState();
  const [isHideSummaryBtn, setIsHideSummaryBtn] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openMissingScoreDialog, setOpenMissingScoreDialog] = useState(false);
  const [unAttemptedQuestions, setUnAttemptedQuestions] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ⭐ AUTO-EVAL + STUDENT STATUS
  const [isAutoEval, setIsAutoEval] = useState(state?.isAutoEval ?? false);
  const [studentStatus, setStudentStatus] = useState(
    state?.studentStatus ?? "",
  );

  const getStorageKey = () => {
    return `review_${state.assessmentId}_${state.studentId}`;
  };

  // ⭐ isReadOnly / canEditMarks flags — top pe define
  const isReadOnly = isAutoEval && studentStatus === "completed";
  const canEditMarks = isAutoEval && studentStatus === "review";

  useEffect(() => {
    if (!responseAnswers || responseAnswers.length === 0) return;
    localStorage.setItem(getStorageKey(), JSON.stringify(responseAnswers));
  }, [responseAnswers]);

  // ⭐ Fallback: agar router state se flags nahi aaye to API se lo
  useEffect(() => {
    if (state?.isAutoEval !== undefined && state?.studentStatus !== undefined)
      return;
    if (!state?.assessmentId) return;

    const fetchFlag = async () => {
      try {
        const res = await axios.get(
          `/api/v1/assessment/get/${state.assessmentId}`,
        );
        if (state?.isAutoEval === undefined) {
          setIsAutoEval(!!res.data.data?.autoEvalEnabled);
        }
        if (state?.studentStatus === undefined) {
          setStudentStatus(res.data.data?.status ?? "");
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchFlag();
  }, [state?.assessmentId, state?.isAutoEval, state?.studentStatus]);

  useEffect(() => {
    getStudentStatus();
    getStudentResponse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoEval]);

  const getStudentResults = async () => {
    try {
      const res = await axios.get(
        `/api/v1/assessment/${state.assessmentId}/studentResult/student/${state.studentId}/get`,
      );

      if (res) {
        let content = res?.data?.data;
        if (content.assessment.isAdaptive) {
          if (res?.data?.data?.difficulty_history.length === 0) {
            setPopupOpen(true);
            return;
          }
          let questions = res?.data?.data?.results;
          content.results = null;
          let newQuestion = [];
          for (let i = 0; i < content.difficulty_history.length; i++) {
            newQuestion.push(
              questions[content.difficulty_history[i].questionNo],
            );
          }
          content.results = newQuestion;
        }

        let results = content.results;
        setStudentResults(results);
        setStudentResultData(content);
        let qsNoLabels = [];

        if (res.data.data.assessment) {
          const resultArray = results.map((curr, index) => {
            const resultObj = {
              questionNumber: `Q${index + 1}`,
            };
            qsNoLabels.push(resultObj.questionNumber);
            return resultObj;
          });
          setChartData(resultArray);
        }

        // ⭐ Auto-eval: confidence + marks merge karo (manual grades bhi)
        if (isAutoEval && Array.isArray(results)) {
          setResponseAnswers((prev) =>
            prev.map((ans, i) => {
              const r = results[i];
              if (!r) return ans;

              const hasScore =
                r.obtained_marks !== undefined && r.obtained_marks !== null;
              const scoreValue = hasScore ? Number(r.obtained_marks) : null;

              const isAutoGraded = r.grading_status === "auto_graded";
              const isManual = r.grading_status === "manually_graded";

              return {
                ...ans,
                autoMeta: {
                  confidence: r.confidence ?? null,
                  max_marks: r.max_marks ?? ans.question?.correct_score ?? 0,
                  grading_status: r.grading_status ?? "",
                  hasObtainedMarks: hasScore,
                  isEditable: isAutoGraded && !isManual,
                  // ⭐ NEW FIELDS — AI grading basis ke liye
                  evaluation_criteria: r.evaluation_criteria ?? [],
                  evaluation_explanation: r.evaluation_explanation ?? "",
                  evaluation_method: r.evaluation_method ?? "",
                  evaluator_version: r.evaluator_version ?? "",
                },
                result: {
                  questionResponse:
                    r.question_response?.id ?? ans.result.questionResponse,
                  score: scoreValue,
                  remark: r.comment ?? "",
                  correctScore:
                    r.question_response?.question?.correct_score ??
                    r.max_marks ??
                    ans.result.correctScore,
                },
              };
            }),
          );

          setNewResultId(content.id);
          setIsFirstSubmit(true);
          setResultIds(results.map((r) => r.id));
        }
      }
    } catch (error) {
      console.error("Error fetching student results:", error);
      toast.error("Something went wrong for selected card!!");
    }
  };

  const getStudentStatus = async () => {
    try {
      const res = await axios.get(
        `/api/v1/assessment/studentStatus/assessmentId/${state.assessmentId}/studentId/${state.studentId}`,
      );
      const status = res?.data?.data?.status;
      if (status) setStudentStatus(status);
      if (status === "completed" || isAutoEval) {
        getStudentResults();
      }
    } catch (error) {
      console.error("Error fetching student status:", error);
    }
  };

  const getStudentResponse = async () => {
    setIsLoading(true);

    try {
      const res = await axios.get(
        `/api/v1/assessment/${state.assessmentId}/studentResponse/student/${state.studentId}/getForTeacher`,
      );

      if (res) {
        let apiAnswers = res.data.data.answers.map((answer) => ({
          ...answer,
          result: {
            questionResponse: null,
            score: null,
            remark: "",
            correctScore: null,
          },
        }));

        // ⭐ Restore SIRF tab jab student review me ho (editable stage)
        const canRestore = !isReadOnly;

        if (canRestore) {
          const saved = localStorage.getItem(getStorageKey());
          if (saved) {
            try {
              const parsed = JSON.parse(saved);
              toast.info("Restored previous review data");
              apiAnswers = apiAnswers.map((q, i) => ({
                ...q,
                result: parsed[i]?.result || q.result,
              }));
            } catch (e) {
              console.warn("Failed to parse saved review data", e);
              localStorage.removeItem(getStorageKey());
            }
          }
        }

        setStudentResponse(res.data.data);
        setResponseAnswers(apiAnswers);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getEvaluation = async () => {
    try {
      const res = await axios.get(
        `/api/v1/assessment/${state.assessmentId}/studentAssessmentStats/student/${state.studentId}/get`,
      );

      res && setEvaluationData(res.data.data);
      setPublishResult(!publishResult);
    } catch (error) {
      setIsError(true);
      if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      }
      setInProgress(false);
      if (isError) {
        assessmentReviewDialogRef.current.openDialog();
      }
    }
  };

  const CheckUnAttemptedQuestionsByTeacher = () => {
    const unAttemptedQuestions = responseAnswers
      .map((answer, index) => {
        if (
          answer.result?.score === null ||
          answer.result?.score === undefined
        ) {
          return `Q${index + 1}. ${answer.question.title}`;
        }
        return null;
      })
      .filter(Boolean);

    if (unAttemptedQuestions.length > 0) {
      setUnAttemptedQuestions(unAttemptedQuestions);
    }
    const hasMissingScores = unAttemptedQuestions.length > 0;

    if (hasMissingScores) {
      setOpenMissingScoreDialog(true);
    } else {
      handleSubmitResult();
    }
  };

  const handleSubmitResult = async () => {
    if (isSubmitting) return;

    let results = [];
    let newResult = {
      id: null,
      teacher_id: teacher_id,
      student_id: state.studentId,
    };

    responseAnswers.map((answer) =>
      results.push({
        question_response_id: answer.result.questionResponse,
        comment: answer.result.remark,
        correct_score: answer.result.correctScore,
        obtained_marks:
          answer.result.score === null ? 0 : Number(answer.result.score),
      }),
    );
    newResult.results = results;

    setIsSubmitting(true);
    setIsDisableSubmit(true);
    try {
      let res;
      if (isFirstSubmit) {
        const updatedResults = results.map((result, index) => ({
          ...result,
          id: resultIds[index],
        }));

        newResult.results = updatedResults;
        newResult.id = newResultId;
        res = await axios.put(
          `/api/v1/assessment/${state.assessmentId}/studentResult/update`,
          newResult,
        );
      } else {
        res = await axios.post(
          `/api/v1/assessment/${state.assessmentId}/studentResult/create`,
          newResult,
        );
        const { data } = res.data;
        const { id: assessmentResultId } = data;
        setNewResultId(assessmentResultId);
        const submittedResults = data.results;
        if (submittedResults) {
          const updatedResultIds = submittedResults.map((result) => result.id);
          setResultIds(updatedResultIds);
        }
      }
      if (res) {
        toast.success(res.data.message);
        localStorage.removeItem(getStorageKey());
        setIsDisableSubmit(false);
        setIsFirstSubmit(true);
        getEvaluation();
        navigate("/onreviewstudentlist", {
          state: { assessmentId: res?.data?.data?.assessment_id },
        });
      }
    } catch (error) {
      setIsDisableSubmit(false);
      setIsError(true);
      if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      }
      if (isError) {
        assessmentReviewDialogRef.current.openDialog();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const difficultyLevels = ["Very Hard", "Hard", "Medium", "Easy", "Very Easy"];
  const skillsLevels = [
    "Create",
    "Evalute",
    "Analyze",
    "Apply",
    "Understand",
    "Remember",
  ];

  useEffect(() => {
    if (studentResults.length > 0) {
      getDifficultyName(studentResults);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentResults, nextQuestion]);

  const getDifficultyName = (results) => {
    const questionTypeMap = {
      "Very Easy": 1,
      Easy: 2,
      Medium: 3,
      Difficult: 4,
      "Very Difficult": 5,
    };
    const questionTypeMapSkill = {
      Create: 6,
      Evaluate: 5,
      Analyze: 4,
      Apply: 3,
      Understand: 2,
      Remember: 1,
    };
    let currectQues = [];
    for (let i = 0; i < results.length; i++) {
      if (nextQuestion === i) {
        currectQues.push(results[i]);
      }
    }
    const difficultyValue =
      questionTypeMap[
        currectQues[0]?.question_response?.question?.difficulty_level?.name
      ] || 0;
    const skillsValue =
      questionTypeMapSkill[
        currectQues[0]?.question_response?.question?.skill?.name
      ] || 0;
    setDifficulty(difficultyValue);
    setSkillsValue(skillsValue);
  };

  useEffect(() => {
    const getStudentMarksDetails = async () => {
      try {
        const res = await axios.get(
          `/api/v1/assessment/${state.assessmentId}/studentScoreBoard/get/studentId/${state.studentId}`,
        );
        res && setStudentMarksDetails(res?.data?.data);
      } catch (error) {
        console.log("error", error);
      }
    };
    getStudentMarksDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const orangeBtnStyle = {
    backgroundColor: "#F28C28",
    color: "#ffffff",
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "8px",
    px: 3,
    "&:hover": {
      backgroundColor: "#d97706",
    },
  };

  // ⭐ Chip visibility flags
  const showCompletedChip = !isAutoEval && studentResults?.length > 0;
  const showOnReviewChip = !isAutoEval && !(studentResults?.length > 0);

  const showReviewSaveBtn =
    isAutoEval && studentResults?.length > 0 && canEditMarks;
  const showCompletedView =
    isAutoEval && studentResults?.length > 0 && isReadOnly;

  return (
    <>
      <>
        {isError && (
          <ErrorDialog
            error={"Cannot evaluate assessment!"}
            message={errorMessage}
            ref={assessmentReviewDialogRef}
            setIsError={setIsError}
          />
        )}

        <div style={{ height: "100vh", background: "#f5f6fa" }}>
          {/* ================= HEADER ================= */}
          <Paper
            elevation={1}
            sx={{
              mx: 2,
              mt: 2,
              p: 2,
              borderRadius: 2,
            }}
          >
            <Stack spacing={1}>
              {/* Breadcrumb */}
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                flexWrap="wrap"
                useFlexGap
              >
                <img
                  src="/images/Back Arrow.svg"
                  alt=""
                  style={{ cursor: "pointer" }}
                  onClick={() => window.history.back()}
                />

                <Typography
                  variant="body2"
                  sx={{ cursor: "pointer", fontWeight: 500 }}
                  onClick={() => window.history.go(-2)}
                >
                  Assessment /
                </Typography>

                <Typography variant="body2" fontWeight={600}>
                  {studentResponse?.assessment?.name}
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  | {studentResponse?.student?.name}
                </Typography>

                {/* ⭐ Auto Evaluated chip */}
                {isAutoEval && studentResults?.length > 0 && (
                  <Chip
                    icon={<AutoAwesomeRoundedIcon sx={{ fontSize: 14 }} />}
                    label="Auto Evaluated"
                    size="small"
                    sx={{
                      bgcolor: "#ecfdf5",
                      color: "#047857",
                      fontWeight: 700,
                      fontSize: 11,
                      height: 22,
                      "& .MuiChip-icon": { color: "#047857" },
                    }}
                  />
                )}

                {/* ⭐ Completed chip (auto-eval completed) */}
                {isReadOnly && (
                  <Chip size="small" color="success" label="Completed" />
                )}

                {/* ⭐ On Review chip (auto-eval review) */}
                {canEditMarks && (
                  <Chip
                    size="small"
                    label="On Review"
                    sx={{
                      bgcolor: "#fef3c7",
                      color: "#b45309",
                      fontWeight: 700,
                      fontSize: 11,
                      height: 22,
                    }}
                  />
                )}

                {/* Non-auto states */}
                {showCompletedChip && (
                  <Chip size="small" color="success" label="Completed" />
                )}
                {showOnReviewChip && (
                  <Chip size="small" color="warning" label="On Review" />
                )}

                {/* ⭐ Show Summary — sirf completed stage me */}
                {studentResults?.length > 0 && isReadOnly && (
                  <Button
                    size="small"
                    sx={{ ml: "auto" }}
                    onClick={() => {
                      setOpenGraphPopup(true);
                      setIsHideSummaryBtn(true);
                    }}
                  >
                    Show Summary
                  </Button>
                )}
              </Stack>

              {/* Description */}
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ maxWidth: "85%" }}
              >
                {studentResponse?.assessment?.description}
              </Typography>

              {/* Meta Info */}
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2">
                  {studentResponse?.assessment?.subject_id?.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  | Scheduled
                </Typography>
                <Typography variant="body2">
                  {dateHelper(studentResponse?.assessment?.deadline || "")} -{" "}
                  {timeHelper(studentResponse?.assessment?.schedule_time || "")}
                </Typography>

                {studentResponse?.assessment?.isAdaptive && (
                  <img src="/images/adaptiveImg.png" alt="" width={90} />
                )}
                {studentResponse?.assessment?.autoEvalEnabled && (
                  <img src="/images/auto-eva.png" alt="" width={60} />
                )}
              </Stack>
            </Stack>
          </Paper>

          {/* ================= QUESTION NAV ================= */}
          {!isLoading && responseAnswers.length > 0 && (
            <Paper
              elevation={0}
              sx={{
                mx: 2,
                mt: 2,
                p: 1.5,
                borderRadius: 2,
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Questionnobox
                  setNextQuestion={setNextQuestion}
                  nextQuestion={nextQuestion}
                  totalResponse={responseAnswers?.length}
                />

                <Stack direction="row" spacing={1}>
                  {responseAnswers.length !== 1 && (
                    <Button
                      variant="outlined"
                      sx={orangeBtnStyle}
                      disabled={nextQuestion === 0}
                      onClick={() =>
                        nextQuestion > 0 && setNextQuestion(nextQuestion - 1)
                      }
                    >
                      Previous
                    </Button>
                  )}

                  {/* ⭐ Auto-eval review case */}
                  {showReviewSaveBtn ? (
                    nextQuestion !== responseAnswers.length - 1 ? (
                      <Button
                        sx={orangeBtnStyle}
                        variant="contained"
                        onClick={() =>
                          nextQuestion < responseAnswers.length &&
                          setNextQuestion(nextQuestion + 1)
                        }
                      >
                        Next
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="success"
                        startIcon={<EditRoundedIcon />}
                        disabled={isDisableSubmit}
                        onClick={CheckUnAttemptedQuestionsByTeacher}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          borderRadius: "8px",
                          px: 3,
                        }}
                      >
                        {isDisableSubmit ? "Saving..." : "Review & Save"}
                      </Button>
                    )
                  ) : showCompletedView ? (
                    /* ⭐ Auto-eval completed: sirf Next */
                    nextQuestion !== responseAnswers.length - 1 && (
                      <Button
                        sx={orangeBtnStyle}
                        variant="contained"
                        onClick={() =>
                          nextQuestion < responseAnswers.length &&
                          setNextQuestion(nextQuestion + 1)
                        }
                      >
                        Next
                      </Button>
                    )
                  ) : nextQuestion !== responseAnswers.length - 1 ? (
                    <Button
                      sx={orangeBtnStyle}
                      variant="contained"
                      onClick={() =>
                        nextQuestion < responseAnswers.length &&
                        setNextQuestion(nextQuestion + 1)
                      }
                    >
                      Next
                    </Button>
                  ) : (
                    !studentResults?.length > 0 && (
                      <Button
                        variant="contained"
                        color="success"
                        disabled={isDisableSubmit}
                        onClick={CheckUnAttemptedQuestionsByTeacher}
                      >
                        {isDisableSubmit ? "Submitting..." : "Submit"}
                      </Button>
                    )
                  )}
                </Stack>
              </Stack>
            </Paper>
          )}

          {/* ================= QUESTIONS SCROLL ================= */}
          <Box
            sx={{
              mx: 2,
              mt: 2,
              height: "calc(100vh - 330px)",
              overflowY: "auto",
              pb: 2,
            }}
            className="orange-scrollBar"
          >
            {isLoading ? (
              <Box textAlign="center" mt={10}>
                <img src="/gif/LoaderDot.gif" alt="" width={80} />
                <Typography mt={1} fontWeight={600}>
                  Loading questions...
                </Typography>
              </Box>
            ) : responseAnswers.length > 0 ? (
              <div className="row">
                <div
                  className={
                    studentResponse?.assessment?.isAdaptive ? "col-8" : "col-12"
                  }
                >
                  {studentResponse?.assessment?.isAdaptive &&
                  studentResults[nextQuestion]?.question_response ? (
                    studentResults[nextQuestion]?.question_response?.question
                      ?.type?.type === "multiple choice" ||
                    studentResults[nextQuestion]?.question_response?.question
                      ?.type?.is_manually_graded === false ? (
                      <McqQuestion
                        questionNumber={nextQuestion}
                        response={studentResults[nextQuestion]}
                        setResponseAnswers={setStudentResults}
                        studentResults={studentResults}
                        isAdaptive
                      />
                    ) : (
                      <UploadQuestion
                        questionNumber={nextQuestion}
                        response={studentResults[nextQuestion]}
                        setResponseAnswers={setStudentResults}
                        studentResults={studentResults}
                        isAdaptive
                      />
                    )
                  ) : responseAnswers[nextQuestion]?.question?.type?.type ===
                      "multiple choice" ||
                    responseAnswers[nextQuestion]?.question?.type
                      ?.is_manually_graded === false ? (
                    <McqQuestion
                      questionNumber={nextQuestion}
                      response={responseAnswers[nextQuestion]}
                      setResponseAnswers={setResponseAnswers}
                      studentResults={studentResults}
                      isAutoEvalMode={isAutoEval}
                      isReadOnly={isReadOnly}
                    />
                  ) : (
                    <UploadQuestion
                      questionNumber={nextQuestion}
                      response={responseAnswers[nextQuestion]}
                      setResponseAnswers={setResponseAnswers}
                      studentResults={studentResults}
                      isAutoEvalMode={isAutoEval}
                      isReadOnly={isReadOnly}
                    />
                  )}
                </div>

                {/* Adaptive Side Panel */}
                {studentResponse?.assessment?.isAdaptive && (
                  <div className="col-4 d-flex">
                    <ProgressBar
                      title="Difficulty"
                      levels={difficultyLevels}
                      progress={difficulty * 20}
                    />
                    <ProgressBar
                      title="Skills"
                      levels={skillsLevels}
                      progress={skillsValue * 16.67}
                    />
                  </div>
                )}
              </div>
            ) : (
              <Box textAlign="center" mt={10}>
                <img src="/images/no-data.png" width={120} />
                <Typography fontWeight={600} mt={1}>
                  No Records Found
                </Typography>
              </Box>
            )}
          </Box>
        </div>
      </>

      {openGraphPopup && (
        <AdaptiveEvalutionGraph
          assessmentisAdaptive={studentResponse?.assessment?.isAdaptive}
          isHideSummaryBtn={isHideSummaryBtn}
          studentResultData={studentResultData}
          chartData={chartData}
          studentMarksDetails={studentMarksDetails}
          setOpenGraphPopup={setOpenGraphPopup}
          studentName={studentResponse?.student?.name}
          assessmentData={state?.assessmentData}
        />
      )}
      {popupOpen && <PopupforNoQsAttempt />}

      <Dialog
        open={openMissingScoreDialog}
        onClose={() => setOpenMissingScoreDialog(false)}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "blue" }}>
          Pending Marks
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Some questions are missing correct scores. Please review them before
            submitting.
          </DialogContentText>

          <Box
            sx={{
              mb: 2,
              p: 2,
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              backgroundColor: "#f9fafb",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: 1, color: "gray.700" }}
            >
              Marks are still pending for the following questions:
            </Typography>
            <List dense>
              {unAttemptedQuestions.map((q, idx) => (
                <ListItem
                  key={idx}
                  sx={{
                    pl: 0,
                    "&:before": {
                      content: '"•"',
                      color: "#ef4444",
                      display: "inline-block",
                      width: "1em",
                      marginLeft: "-1em",
                    },
                  }}
                >
                  <ListItemText primary={q} />
                </ListItem>
              ))}
            </List>
          </Box>

          <DialogContentText
            sx={{
              fontWeight: "bold",
              color: "red",
              border: "1px solid #f87171",
              borderRadius: "8px",
              padding: "8px",
              backgroundColor: "#fee2e2",
            }}
          >
            ⚠️ Important Note: If you continue, all unanswered questions will be
            marked as <strong>0 marks</strong>.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setOpenMissingScoreDialog(false);
              handleSubmitResult();
            }}
          >
            Continue
          </Button>
          <Button
            variant="outlined"
            onClick={() => setOpenMissingScoreDialog(false)}
          >
            Go Back
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AllQuestions;
